/* Copyright (C) 2019 SmartboxTv S.A. - All rights reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Erasmo Marín <emarin@smartboxtv.com>
 */

import { observable, action, ObservableMap, toJS } from 'mobx';
import { generateList } from './actionCreator';
import _ from '../translations';

class TemplatesStore {
    @observable collection = new ObservableMap();
    @observable details = new ObservableMap();

    constructor() {
        this.baseUrl = '/api/core/templates';
    }

    @action
    reset = () => {
        this.collection.clear();
        this.details.clear();
    };

    @action.bound
    async listAll({ params = {} } = {}) {
        const hash = 'all';
        params.paginate = false;

        return await generateList({
            hash,
            params,
            url: this.baseUrl,
            store: this,
            customError: _('There was a problem listing templates'),
        })();
    }

    get templates() {
        const all = toJS(this.collection.get('all'));
        if (all && all.items) return all.items;
        return [];
    }
}

export default new TemplatesStore();
